export const triggerAnalytics = (payload, key = 'click') => {
  return window?.LIFE_CYCLE_EVENT_BUS?.trigger?.(`questions-and-answers.${key}`, payload);
};